import * as React from 'react'
import { FormItemHorizontal, FormItemProps } from "./FormItemHorizontal";
import { Loadable } from "../Pages/EditCreate/Loadable";

type Props = { password: boolean };
export const InputTextGroup = (props: Partial<Props> & FormItemProps & React.InputHTMLAttributes<HTMLInputElement>) => {
    const { password, title, vertical, labelColumns, columns, ...inputAttributes } = props;    
        return (
            <FormItemHorizontal title={title} vertical={vertical} labelColumns={labelColumns} columns={columns} >
                <input className='form-control' type={password ? 'password' : 'text'} {...inputAttributes} />
            </FormItemHorizontal>
    );
}

export const CheckboxGroup = (props: FormItemProps & React.InputHTMLAttributes<HTMLInputElement>) => {
    const { title, vertical, labelColumns, columns, ...inputAttributes } = props;    
    return (
        <FormItemHorizontal vertical={vertical} labelColumns={labelColumns} columns={columns} >
            <div className="checkbox">
                <label>
                    <input type="checkbox" {...inputAttributes} /> {title}
                </label>
            </div>
        </FormItemHorizontal>
    );
}

// Loadable group is used to render a spinner with default value during data loading
type LoadableProps = { value: string, isLoading: boolean };
export const LoadableGroup = (props: FormItemProps & LoadableProps & Readonly<{ children?: React.ReactNode }>) => {
    const { title, vertical, labelColumns, columns, value, isLoading, children } = props;    
    return (
            <FormItemHorizontal title={title} vertical={vertical} labelColumns={labelColumns} columns={columns} >
                <Loadable value={value} isLoading={isLoading}>
                    {children}
                </Loadable>
            </FormItemHorizontal>
    );
}

type LabelGroupProps = { value: string };
export const LabelGroup = (props: FormItemProps & LabelGroupProps) => {
    const { title, vertical, labelColumns, columns, value } = props;
        return (
            <FormItemHorizontal title={title} vertical={vertical} labelColumns={labelColumns} columns={columns} >
                <label className="form-control-static">{value}</label>
            </FormItemHorizontal>
    );
}

type LevelGroupProps = { unitName: string };
export const LevelGroup = (props: LevelGroupProps & FormItemProps & React.InputHTMLAttributes<HTMLInputElement>) => {
    const { unitName, title, vertical, labelColumns, columns, ...inputAttributes } = props;    
        return (
            <FormItemHorizontal title={title} vertical={vertical} labelColumns={labelColumns} columns={columns} >
                <div className="input-group">
                    <input className='form-control' type={unitName == "C" ? "number" : "text"} {...inputAttributes} />
                    <span className="input-group-addon" style={{minWidth: 50}}>{unitName}</span>
                </div>
            </FormItemHorizontal>
    );
}


// WEBPACK FOOTER //
// ./src/app/components/Forms/Groups.tsx